export default {
    title: 'Media players',
    description: 'Manage organization-level player presets. These presets are available across all workspaces.',
    logo: 'Player logo',
    logoDescription: 'Upload a default logo for all embedded players. Workspaces can override this with their own logo.',
    logoHelper: 'PNG, JPEG or WebP. Recommended: transparent background.',
    logoSaved: 'Logo settings saved',
    logoError: 'Failed to save logo settings',
}
